import React from 'react';
import { useSpring, animated } from 'react-spring';
import PropTypes from 'prop-types';

const propTypes = {
  speedValues: PropTypes.oneOfType([PropTypes.object]).isRequired,
  scrollPos: PropTypes.number.isRequired,
};

const Ground = ({ scrollPos, speedValues }) => {
  const { speedFast } = useSpring({
    from: { speedFast: [scrollPos, 0, 0] },
    to: { speedFast: [speedValues.fast, 0, 0] },
  });
  return (
    <div className="floor-container">
      <animated.div
        style={{
          transform: speedFast.to(
            (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
          ),
        }}
      >
        <div className="florest-floor" />
        <div className="cave-floor" />
        <div className="cave-sub-floor" />
        <div className="top-sand-floor" />
        <div className="background-sea" />
        <div className="background-sand" />
        <div className="sea-sand-floor" />
        <div className="water" />
        <div className="left-island-floor" />
        <div className="island-floor" />
        <div className="island-waves" />
        <div className="left-sand" />
      </animated.div>
    </div>
  );
};

export default Ground;

Ground.propTypes = propTypes;
